import { TenantUserUtils } from '../model/tenant-user-utils'

/**
 * Exposes the pure {@link TenantUserUtils} helpers to the component layer.
 * Components and views must not value-import `model/` directly (the MVVM
 * internal-import rule); this composable is the blessed indirection.
 */
export function useTenantUserUtils() {
  return { TenantUserUtils }
}
